/**
 * @generated SignedSource<<a59f259beefde0ea590e48c57f09597f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutCreditCards_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCardForm_viewer" | "CheckoutCreditCardListWrapper_viewer" | "CheckoutPaymentError_viewer" | "checkoutPayment_viewer">;
  readonly " $fragmentType": "CheckoutCreditCards_viewer";
};
export type CheckoutCreditCards_viewer$key = {
  readonly " $data"?: CheckoutCreditCards_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutCreditCards_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutCreditCards_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCardListWrapper_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutCreditCardForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutPaymentError_viewer"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "checkoutPayment_viewer",
      "selections": [
        {
          "alias": "achDisabled",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "disableACHCheckout"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"disableACHCheckout\")"
        },
        {
          "alias": "disableApplePay",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "disableApplePay"
            }
          ],
          "kind": "ScalarField",
          "name": "isEnabled",
          "storageKey": "isEnabled(key:\"disableApplePay\")"
        },
        {
          "alias": "isKlarnaNegotiationEnabled",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "klarnaNegotiationFlow"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"klarnaNegotiationFlow\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Token",
          "kind": "LinkedField",
          "name": "clientToken",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "environment",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "57504a2e0aaed9c26257ea74cb12d98f";

export default node;
